
import { ProfessionData } from '../types/professionTypes';

export const electricien: ProfessionData = {
  title: "Électricien",
  slug: "electricien",
  description: "Solutions de recyclage pour les déchets électriques et électroniques",
  icon: "Zap",
  heroImage: "/lovable-uploads/328f4f86-9058-4b88-b6b8-5bcc727eb914.png",
  wasteMaterials: [
    {
      type: "Câbles électriques",
      description: "Câbles cuivre et aluminium avec ou sans gaine, à haute valeur de recyclage.",
      solutions: ["Dénudage et valorisation", "Collecte en big bag"],
      environmentalBenefit: "Récupération de métaux précieux et réduction des déchets"
    },
    {
      type: "Équipements électriques",
      description: "Tableaux, disjoncteurs, transformateurs et autres composants électriques.",
      solutions: ["Collecte DEEE professionnels", "Dépollution sécurisée"],
      environmentalBenefit: "Traitement conforme des substances dangereuses"
    },
    {
      type: "Luminaires et ampoules",
      description: "Solutions pour le recyclage d'éclairages et sources lumineuses diverses.",
      solutions: ["Bacs de collecte spécifiques", "Traçabilité complète"],
      environmentalBenefit: "Récupération des terres rares et prévention pollution"
    }
  ],
  relatedProfessions: ["plombier", "chauffagiste", "menuisier"]
};
